import $ from 'jquery'
import messageResource from './messageResource'
import PasswordHintTooltip from './util/passwords/PasswordHintTooltip'
import PasswordPolicyManager from './util/passwords/PasswordPolicyManager'
import {getPasswordValidator} from './util/passwords/PasswordAsyncValidator'
import PasswordAsyncValidator from './util/passwords/PasswordAsyncValidator'

export default function ActivationPageController() {}

ActivationPageController.prototype.init = function()
{
    this.form = document.getElementById( "activationForm" );

    this.newPasswordText = document.getElementById( "newPwd" );
    this.newPasswordConfirmText = document.getElementById( "newPwdConfirm" );
    this.newPasswordField = document.getElementById( "newPassword" );

    this.errorMessagesArea = $("#errorMessagesArea" );
    this.whiteBoxBody = $( "#whiteBoxWithLogoBody" );

    $(this.newPasswordText).attr('placeholder', messageResource.getMessage("activation_page.password_field.placeholder")).placeholder();
    $(this.newPasswordConfirmText).attr('placeholder', messageResource.getMessage("activation_page.confirm_password_field.placeholder")).placeholder();

    this.activationButton = $("#activationButton");
    this.activationButton.click(() => this.submitForm())

    $(this.newPasswordText).keyup(() => this.hideError())
    $(this.newPasswordConfirmText).keyup(() => this.hideError())

    const passwordHint = new PasswordHintTooltip(PasswordPolicyManager, {dialogOffsets: {left: 15, top: 0}}).init($("#tooltipContainer"))
    const passwordHintLink = $(".passwordHintLink")
    passwordHintLink.click(() => {
        passwordHint.showAt(passwordHintLink, {my: "left center", at: "right center"});
    });
    this.passwordValidator = getPasswordValidator({
        onValidationStart: this.onValidationStart.bind(this),
        onValidationEnd: this.onValidationEnd.bind(this)
    })

    return this;
};

ActivationPageController.prototype.setPasswordErrorJson = function(json)
{
    if (json) {
        this.showError(PasswordPolicyManager.getErrorMessage(json));
    }
}

ActivationPageController.prototype.submitForm = function()
{
    if ( this.inProgress )
        return;
    this.validate();
};

ActivationPageController.prototype.clearInputs = function()
{
    $(this.newPasswordText).pVal("");
    $(this.newPasswordConfirmText).pVal("");
};

ActivationPageController.prototype.onValidationStart = function()
{
    this.setInProgressState();
}

ActivationPageController.prototype.onValidationEnd = function(errorCode, validationResultJson)
{
    if (errorCode) {
        this.setNormalState();
        switch (errorCode) {
            case PasswordAsyncValidator.ValidationErrors.PASSWORD_EMPTY:
                this.showError(messageResource.getMessage("activation_page.error.password_empty", [], true));
                break;
            case PasswordAsyncValidator.ValidationErrors.PASSWORD_COPY_EMPTY:
            case PasswordAsyncValidator.ValidationErrors.PASSWORDS_DO_NOT_MATCH:
                this.showError(messageResource.getMessage("activation_page.error.passwords_do_not_match", [], true));
                break;
            case PasswordAsyncValidator.ValidationErrors.PASSWORD_RESTRICTIONS_VIOLATED:
                this.setPasswordErrorJson(validationResultJson);
                break;
            default:
                console.error("Unprocessed error code:", errorCode);
        }
    } else {
        this.newPasswordField.value = $(this.newPasswordText).pVal();
        this.clearInputs();
        this.form.submit();
    }
}

ActivationPageController.prototype.validate = function()
{
    var password = $(this.newPasswordText).pVal();
    var passwordCopy = $(this.newPasswordConfirmText).pVal();
    this.hideError();
    this.passwordValidator.setState({
        password, passwordCopy, forcePasswordCheck: true
    });
};

ActivationPageController.prototype.showError = function( errorMessage )
{
    this.errorMessagesArea.find( "#errorSpan" ).html( errorMessage );
    this.errorMessagesArea.show();
};

ActivationPageController.prototype.hideError = function()
{
    this.errorMessagesArea.hide();
};

ActivationPageController.prototype.setInProgressState = function()
{
    this.inProgress = true;
    this.whiteBoxBody.addClass( "inProgress" );
};

ActivationPageController.prototype.setNormalState = function()
{
    this.inProgress = false;
    this.whiteBoxBody.removeClass( "inProgress" );
};


// WEBPACK FOOTER //
// ./web/js/activation_page_controller.js